import React from 'react'
import bodymovin from 'lottie-web'

//let bodymovin = {}

class Bodymovin extends React.Component {

	constructor() {
		super()
		this.animationLoaded = this.animationLoaded.bind(this)
		this.setElement = this.setElement.bind(this)
		this.element = null
	}

	animationLoaded() {
		if (this.props.animationLoaded) {
			this.props.animationLoaded()
		}
		//for debugging fast
		//this.animation.setSpeed(10)
	}

	componentWillReceiveProps(props) {
		if (props.animationData !== this.props.animationData || props.path !== this.props.path) {
			if (this.animation) {
				this.animation.destroy()
				this.animation = null
			}
		}
	}

	componentDidUpdate() {
		this.attachAnimation()
	}

	setElement(elem) {
		this.element = elem
		this.attachAnimation()
	}

	checkListeners() {
		if (!this.animation) {
			return
		}
		if (this.props.listeners.onLoaded) {
			this.animation.addEventListener('DOMLoaded', this.props.listeners.onLoaded)
		}
		if (this.props.listeners.onLoopComplete) {
			this.animation.addEventListener('loopComplete', this.props.listeners.onLoopComplete)
		}
		if (this.props.listeners.onComplete) {
			this.animation.addEventListener('complete', this.props.listeners.onComplete)
		}
	}

	attachAnimation() {
		if (!this.animation && this.element && (this.props.animationData || this.props.path)) {
			try {
				const params = {
					container: this.element,
					renderer: 'svg',
					autoplay: this.props.autoplay,
					loop: this.props.loop,
					rendererSettings: {
						progressiveLoad: true,
						preserveAspectRatio: this.props.preserveAspectRatio || 'xMidYMid meet',
						viewBoxSize: this.props.viewBoxSize || '',
					},
				}
				if (this.props.animationData) {
					params.animationData = this.props.animationData
				} else if (this.props.path) {
					params.path = this.props.path
				}
				if (this.props.rendererSettings) {
					params.rendererSettings = {...params.rendererSettings, ...this.props.rendererSettings}
				}
				this.animation = bodymovin.loadAnimation(params)
				this.animation._random = Math.random()
				this.animation.addEventListener('DOMLoaded', this.animationLoaded)
				this.checkListeners()
			} catch (err) {
				this.element.innerHTML = ''
			}
		}
	}

	goToAndPlay(num, isFrame) {
		if (this.animation) {
			this.animation.goToAndPlay(num, isFrame)
		}
	}

	goToAndStop(num, isFrame) {
		if (this.animation) {
			this.animation.goToAndStop(num, isFrame)
		}
	}

	playSegments(segments, forceFlag) {
		if (this.animation) {
			this.animation.playSegments(segments, forceFlag)
		}
	}

	setSegment(init, end) {
		if (this.animation) {
			this.animation.setSegment(init, end)
		}
	}

	resetSegments(flag) {
		if (this.animation) {
			this.animation.resetSegments(flag)
		}
	}

	play() {
		if (this.animation) {
			this.animation.play()
		}
	}

	stop() {
		if (this.animation) {
			this.animation.stop()
		}
	}

	loop(value) {
		if (this.animation) {
			this.animation.loop = value
		}
	}

	setSpeed(value) {
		if (this.animation) {
			this.animation.setSpeed(value)
		}
	}

	getCurrentFrame() {
		if (this.animation) {
			return this.animation.currentRawFrame
		}
		return 0
	}

	getFirstFrame() {
		if (this.animation) {
			return this.animation.firstFrame
		}
		return 0
	}

	render() {
		var cloned = React.cloneElement(
			this.props.children,
			{
				ref: this.setElement,
			}
		)
		return cloned
	}

	componentWillUnmount() {
		if (this.animation) {
			this.animation.destroy()
			this.animation = null
		}
		if (this.element) {
			this.element = null
		}
	}
}

Bodymovin.defaultProps = {
	autoplay: true,
	loop: false,
	listeners: {},
}

export default Bodymovin
